
<div *ngIf="termsConditions" [innerHTML]="termsConditions.longDescription">

</div>
